// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_hu","advertCardList_max6":"c-a_hv"};